import axios from 'axios';
const PROTOCOL = 'https';
const BASE = window.location.hostname;
const PORT = 443;
const auth = axios.create({
    baseURL: `${PROTOCOL}://${BASE}:${PORT}/login/`
});
export {PROTOCOL,BASE,PORT,auth}
